import { CarbonProgramResult, PRACTICE_SLUG, PracticeSlug } from "models";

export const getBaselineYearsByPracticeType = (carbonProgramResult: CarbonProgramResult): { [k in PracticeSlug]?: number[] } => {
  if (!carbonProgramResult) return {};

  const practicesList = Object.values(PRACTICE_SLUG);

  if ("error" in carbonProgramResult) {
    return practicesList.reduce(
      (acc, practice) => {
        acc[practice] = [];
        return acc;
      },
      {} as { [k in PracticeSlug]?: number[] }
    );
  }

  const baselineYearsByPractice = practicesList.reduce(
    (acc, practice) => {
      const practiceYears = carbonProgramResult.fieldOutcomes?.[practice]?.years;
      if (!practiceYears) {
        acc[practice] = [];
        return acc;
      }

      const baselineYears = Object.entries(practiceYears)
        .filter(([_year, fieldOutcome]) => fieldOutcome.isBaselineYear)
        .map(([year, _fieldOutcome]) => parseInt(year));

      acc[practice] = baselineYears;
      return acc;
    },
    {} as { [k in PracticeSlug]?: number[] }
  );

  return baselineYearsByPractice;
};

export type FieldBaselineYearRange = { startYear: number; endYear: number };

// null when the field has no baseline years (inventory programs and unenrolled fields never have any)
export const getFieldBaselineYearRange = (baselineYears: number[]): FieldBaselineYearRange | null => {
  if (baselineYears.length === 0) return null;

  return { startYear: Math.min(...baselineYears), endYear: Math.max(...baselineYears) };
};
